
import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchAccount = (accountId) => api.get(`/account/${accountId}`).then((res) => res.data);

export default function useAccount(accountId) {
  return useQuery(['accounts', accountId], () => fetchAccount(accountId));
}